import { render, staticRenderFns } from "./addforeignEmployess.vue?vue&type=template&id=7865c6ed&"
import script from "./addforeignEmployess.vue?vue&type=script&lang=js&"
export * from "./addforeignEmployess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports